import { ChangeDetectorRef, Component, forwardRef, HostBinding, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {merge, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CdkNavigationItem} from '@cdk/types';
import {CdkNavigationService} from '@cdk/components/navigation/navigation.service';
import {LoginService} from '../../../../../app/main/auth/login/login.service';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import { CdkNavVerticalCollapsableComponent } from '../collapsable/collapsable.component';
import { CdkNavVerticalItemComponent } from '../item/item.component';

@Component({
    selector: 'cdk-nav-vertical-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
        imports: [
    NgClass,
    TranslateDirective,
    forwardRef(() => CdkNavVerticalCollapsableComponent),
    CdkNavVerticalItemComponent
]
})
export class CdkNavVerticalGroupComponent implements OnInit, OnDestroy
{
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _cdkNavigationService = inject(CdkNavigationService);
    _loginService = inject(LoginService);

    @HostBinding('class')
    classes = 'nav-group nav-item';

    @Input()
    item: CdkNavigationItem;

    // Private
    private _unsubscribeAll: Subject<any>;

    isGrantedRole: boolean;
    isCoordenador: boolean;



    /**
     * Constructor
     */

    constructor()
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to navigation item
        merge(
            this._cdkNavigationService.onNavigationItemAdded,
            this._cdkNavigationService.onNavigationItemUpdated,
            this._cdkNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
         .subscribe(() => {

             // Mark for check
             this._changeDetectorRef.markForCheck();
         });

        this.isGrantedRole = true;

        if (this.item.role) {
            this.isGrantedRole = false;
            if (Array.isArray(this.item.role)) {
                this.item.role.forEach((role) => {
                    if (!this.isGrantedRole) {
                        this.isGrantedRole = this._loginService.isGranted(role);
                    }
                });
            } else {
                this.isGrantedRole = this._loginService.isGranted(this.item.role);
            }
        }

        this.isCoordenador = this._loginService.isCoordenador();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

}
